export var ContactStatus;
(function (ContactStatus) {
    ContactStatus["ACTIVE"] = "ACTIVE";
    ContactStatus["ARCHIVED"] = "ARCHIVED";
})(ContactStatus || (ContactStatus = {}));
export var ContactDefaultTaxInclusiveType;
(function (ContactDefaultTaxInclusiveType) {
    ContactDefaultTaxInclusiveType["INCLUSIVE"] = "INCLUSIVE";
    ContactDefaultTaxInclusiveType["EXCLUSIVE"] = "EXCLUSIVE";
    ContactDefaultTaxInclusiveType["NONE"] = "NONE";
    ContactDefaultTaxInclusiveType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ContactDefaultTaxInclusiveType["NOT_YET_SYNCED"] = "NOT_YET_SYNCED";
})(ContactDefaultTaxInclusiveType || (ContactDefaultTaxInclusiveType = {}));
export var StatementLineType;
(function (StatementLineType) {
    StatementLineType["Invoice"] = "invoice";
    StatementLineType["CreditNote"] = "credit_note";
})(StatementLineType || (StatementLineType = {}));
export class TestContact {
    constructor(orgId, version, currencyCode = `USD`) {
        this.id = 1;
        this.organisationId = orgId;
        this.defaultCurrency = currencyCode;
        this.name = `Test Contact`;
        this.version = version;
        this.status = ContactStatus.ACTIVE;
        this.externalId = `123`;
        this.hash = `test`;
        this.defaultTaxInclusiveType = ContactDefaultTaxInclusiveType.INCLUSIVE;
        this.addressLine1 = `123 Test St`;
        this.city = `Sydney`;
        this.state = `NSW`;
        this.country = `Australia`;
        this.zipcode = `2000`;
        this.tags = [];
        this.primaryContactPerson = {
            firstName: `Jane`,
            lastName: `Doe`,
            email: `test@example.com`,
            isPrimary: true,
            includeInNotifications: true,
        };
        this.contactPersons = [{
                firstName: `John`,
                lastName: `Doe`,
                email: `test@example.com`,
                isPrimary: false,
                includeInNotifications: true,
            }];
    }
}
export var StatementRelativePeriods;
(function (StatementRelativePeriods) {
    /** Include items ISSUED in the current month */
    StatementRelativePeriods["THIS_MONTH"] = "THIS_MONTH";
    /** Include items ISSUED in the previous month */
    StatementRelativePeriods["PREVIOUS_MONTH"] = "PREVIOUS_MONTH";
    /** Include items ISSUED upto the end of the previous month */
    StatementRelativePeriods["UPTO_PREVIOUS_MONTH"] = "UPTO_PREVIOUS_MONTH";
    /** Include all items upto today*/
    StatementRelativePeriods["ALL_TIME"] = "ALL_TIME";
    /** Include all items including future dated items */
    StatementRelativePeriods["ALL_TIME_INC_FUTURE"] = "ALL_TIME_INC_FUTURE";
})(StatementRelativePeriods || (StatementRelativePeriods = {}));
//# sourceMappingURL=contact.js.map